import { render } from "./DynamicBannerWidget.vue?vue&type=template&id=464ade8a"
import script from "./DynamicBannerWidget.vue?vue&type=script&lang=js"
export * from "./DynamicBannerWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__